import React from "react";
const About =()=>{
    return (
    <div id="about">
        <h1>About</h1>
        <h4>I'M <span style={{color:"rgb(236,168,6)"}}>Swapnil Meshram</span></h4>
        <p>An aspiring full stack web developer. Looking to obtain the
        position of a full stack web developer in a fast-paced tech
        environment to utilize technical skills to get experience in 
        developing customized software based on varying client demand</p>
        <h5>Drop a mail @ <a href="https://mail.google.com/mail/?view=cm&to=swapnilm1908@gmail.com" target="_blank" rel="noreferrer">swapnilm1908@gmail.com</a></h5>
    </div>)
}

export default About;